import React, {useState} from "react";
import useAuth from "../../../utils/CustomHooks/useAuth/useAuth";
import closeIcon from "../../../img/closeIcon.svg";
import activeCheckBox from "../../../img/activeCheckModal.svg";
import notActiveCheckBox from "../../../img/emptyCheckModal.svg";
import CustomSelect from "../../../utils/CustomSelect/CustomSelect";
import NoOptionsAddButton from "../NoOptionsAddButton/NoOptionsAddButton";
import NoOptionsAddElementDictionaryCityModal
    from "../NoOptionsAddElementDictionaryCityModal/NoOptionsAddElementDictionaryCityModal";
import {axiosPostAddNewElementDictionary} from "../../../Api/ApiDictionary/axiosPostAddNewElementDictionary";
import {
    selectApiPostRequestDictionary
} from "../../../utils/SelectApiPostRequestDictionary/selectApiPostRequestDictionary";
import {
    selectApiBodyRequestDictionary
} from "../../../utils/SelectApiBodyRequestDictionary/selectApiBodyRequestDictionary";
import useAxiosPrivate from "../../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";

const NoOptionsAddElementDictionaryModal = (props) => {

    const {
        onCloseModal,
        onHandleConfirmAddElementDictionary,
        isModalMessage,
        isNoOptionMessageValue,
        setModalMessage
    } = props;

    const axiosPrivate = useAxiosPrivate();
    const { dictionaryCities, dictionaryCountries, updateRequestDataDictionary } = useAuth();
    const [isNameElement, setNameElement] = useState('');
    const [isAddressElement, setAddressElement] = useState('');
    const [isSelectedItemDictionary, setSelectedItemDictionary] = useState(null);
    const [isActiveOptionCityModal, setActiveOptionCityModal] = useState(false);
    const [isModalMessageCity, setModalMessageCity] = useState('');
    const [isActiveCheckBox, setActiveCheckBox] = useState(false);

    const optionCities = dictionaryCities.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionDestinationCountry = dictionaryCountries.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    function onCloseCityModal() {
        setModalMessageCity('');
        setActiveOptionCityModal(false);
        setModalMessage('');
    }

    const noOptionsMessageCreateElement = () => {
        return (
            <NoOptionsAddButton
                onHandleOpenAddNewValueModal={() => setActiveOptionCityModal(true)}
            />
        )
    }

    function onHandleConfirmAddElementDictionaryCity (isNoOptionMessageValue, isNameElement, isAddressElement, isSelectedItemDictionary) {
        if (isNoOptionMessageValue === 'city' && (isNameElement === '' || isSelectedItemDictionary === null)) {
            setModalMessageCity('All fields must be filled!');
        } else {
            axiosPostAddNewElementDictionary(axiosPrivate,
                selectApiPostRequestDictionary(isNoOptionMessageValue),
                selectApiBodyRequestDictionary(isNoOptionMessageValue, isNameElement, isAddressElement, isSelectedItemDictionary),
                updateRequestDataDictionary,
                setActiveOptionCityModal,
                setModalMessage)
                setModalMessageCity('');
        }
    }

    return (
        <div className="no-option-add-element-dictionary-modal__container">
            <div className="no-option-add-element-dictionary-modal">
                <div className="no-option-add-element-dictionary-modal__title">
                    <h3>Add new {isNoOptionMessageValue}</h3>
                    <img onClick={() => onCloseModal()} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="no-option-add-element-dictionary-modal-input-block">
                    <label className="no-option-add-element-dictionary-modal-input-block__label">Name of {isNoOptionMessageValue}</label>
                    <input className="no-option-add-element-dictionary-modal-input-block__input"
                           type={'text'}
                           value={isNameElement}
                           onChange={(e) => setNameElement(e.currentTarget.value)}
                    />
                    {(isNoOptionMessageValue === 'vessel' || isNoOptionMessageValue === 'shipper' || isNoOptionMessageValue === 'shipowner') && <div onClick={() => setActiveCheckBox(!isActiveCheckBox)} className="no-option-add-element-dictionary-modal__checkbox">
                        <img src={isActiveCheckBox ? activeCheckBox : notActiveCheckBox} alt={'icon'}/>
                        <p>{isNoOptionMessageValue === 'vessel' ?  'Add flag' : 'Add address'}</p>
                    </div>}
                    {(isNoOptionMessageValue === 'vessel' || isNoOptionMessageValue === 'shipper' || isNoOptionMessageValue === 'shipowner') && isActiveCheckBox === false && <p className="no-option-add-element-dictionary-modal-input-block__error-message">{isModalMessage}</p>}
                </div>
                {isNoOptionMessageValue === 'shipper' || isNoOptionMessageValue === 'shipowner' ?
                    (
                        <>
                            {isActiveCheckBox === true && <div className="no-option-add-element-dictionary-modal-input-block">
                                <label className="no-option-add-element-dictionary-modal-input-block__label">Address {isNoOptionMessageValue}</label>
                                <input className="no-option-add-element-dictionary-modal-input-block__input"
                                       type={'text'}
                                       value={isAddressElement}
                                       onChange={(e) => setAddressElement(e.currentTarget.value)}
                                />
                                <p className="no-option-add-element-dictionary-modal-input-block__error-message">{isModalMessage}</p>
                            </div>}
                        </>
                ) : (
                    <>
                        {isNoOptionMessageValue === 'port' && <div className="no-option-add-element-dictionary-modal-input-block">
                            <label className="no-option-add-element-dictionary-modal-input-block__label">Select city</label>
                            <CustomSelect className="no-option-add-element-dictionary-modal-input-block__select-input"
                                          options={optionCities}
                                          value={isSelectedItemDictionary}
                                          onChange={value => setSelectedItemDictionary(value.value)}
                                          noOptionsMessage={() => noOptionsMessageCreateElement()}
                            />
                            <p className="no-option-add-element-dictionary-modal-input-block__error-message">{isModalMessage}</p>
                        </div>}
                        {isActiveCheckBox === true && <div className="no-option-add-element-dictionary-modal-input-block">
                            <label className="no-option-add-element-dictionary-modal-input-block__label">Select country</label>
                            <CustomSelect className="no-option-add-element-dictionary-modal-input-block__select-input"
                                          options={optionDestinationCountry}
                                          value={isSelectedItemDictionary}
                                          onChange={value => setSelectedItemDictionary(value.value)}
                                          noOptionsMessage={() => noOptionsMessageCreateElement()}
                            />
                            <p className="no-option-add-element-dictionary-modal-input-block__error-message">{isModalMessage}</p>
                        </div>}
                        {isActiveOptionCityModal &&
                             <NoOptionsAddElementDictionaryCityModal
                                 onCloseCityModal={onCloseCityModal}
                                 isModalMessageCity={isModalMessageCity}
                                 onHandleConfirmAddElementDictionaryCity={onHandleConfirmAddElementDictionaryCity}
                             />
                        }
                    </>
                )}
                <div className="no-option-add-element-dictionary-modal__buttons-block">
                    <button onClick={() => onCloseModal()} className="no-option-add-element-dictionary-modal__button-cancel" type={"button"}>Cancel</button>
                    <button onClick={() => onHandleConfirmAddElementDictionary(isNoOptionMessageValue, isNameElement, isAddressElement, isSelectedItemDictionary, isActiveCheckBox)} className="no-option-add-element-dictionary-modal__button-create" type={"button"}>Save</button>
                </div>
            </div>
        </div>
    )
}
export default NoOptionsAddElementDictionaryModal;